var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{
    secondary: _vm.type === "secondary",
    small: _vm.size === "small",
    active: _vm.type === "active"
  },attrs:{"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.value)+" "),(_vm.number >= 0)?_c('div',{staticClass:"number-circle"},[_vm._v("("+_vm._s(_vm.number)+")")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }